interface Props {
  icon?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ icon = "ri-inbox-line", title, desc, actionLabel, onAction }: Props) {
  return (
    <div className="card-surface flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-3xl text-foreground-400">
        <i className={icon} />
      </span>
      <h3 className="font-heading text-lg font-bold text-foreground-900">{title}</h3>
      {desc && <p className="max-w-md text-sm text-foreground-600">{desc}</p>}
      {actionLabel && onAction && (
        <button type="button" onClick={onAction} className="btn-primary mt-2 text-sm">
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}